import { fapp } from '../../fapp'
import template from './index.html'

const pageSettings = () => {
  return {
    title: 'НАСТРОЙКИ',
    currentShow: false,
    newShow: false,
    currentPassword: '',
    newPassword: '',
    async init() {
      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
    },
    async changeMainScreen(val) {
      let mainScreen = 'devices'
      if (val.target.checked) mainScreen = 'cinema'

      this.$store.state.settings.mainScreen = mainScreen
    }
  }
}

export { pageSettings }
